module.exports = __webpack_public_path__ + "static/media/video-clipper-screenshot.74179d3c.png";